'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveSelector$() {
  this.c5h = null;
  this.c5i = false;
  this.c5f = null;
  this.c5g = false;
  this.c5j = null;
  this.c5k = false;
  this.c5l = null;
  this.c5m = false;
}
export { $c_Lpresto_types$DirectiveSelector$ as $c_Lpresto_types$DirectiveSelector$ };
$p = $c_Lpresto_types$DirectiveSelector$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveSelector$;
/** @constructor */
function $h_Lpresto_types$DirectiveSelector$() {
}
export { $h_Lpresto_types$DirectiveSelector$ as $h_Lpresto_types$DirectiveSelector$ };
$h_Lpresto_types$DirectiveSelector$.prototype = $p;
$p.cHr = (function() {
  if ((!this.c5i)) {
    this.c5h = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c5i = true;
  }
  return this.c5h;
});
$p.v8 = (function() {
  if ((!this.c5g)) {
    this.c5f = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c5g = true;
  }
  return this.c5f;
});
$p.cIb = (function() {
  if ((!this.c5k)) {
    this.c5j = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5k = true;
  }
  return this.c5j;
});
$p.cIr = (function() {
  if ((!this.c5m)) {
    this.c5l = new $c_Lpresto_types$DirectiveSelector$$anon$66(this);
    this.c5m = true;
  }
  return this.c5l;
});
$p.a2O = (function(str) {
  try {
    var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(document.querySelector(str));
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().ak(e$2)) {
      var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
  return $x_1.sG();
});
var $d_Lpresto_types$DirectiveSelector$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveSelector$, "presto.types$DirectiveSelector$", ({
  a02: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveSelector$ as $d_Lpresto_types$DirectiveSelector$ };
var $n_Lpresto_types$DirectiveSelector$;
function $m_Lpresto_types$DirectiveSelector$() {
  if ((!$n_Lpresto_types$DirectiveSelector$)) {
    $n_Lpresto_types$DirectiveSelector$ = new $c_Lpresto_types$DirectiveSelector$();
  }
  return $n_Lpresto_types$DirectiveSelector$;
}
export { $m_Lpresto_types$DirectiveSelector$ as $m_Lpresto_types$DirectiveSelector$ };
/** @constructor */
function $c_Lpresto_types$DirectiveSelector$$anon$66(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DirectiveSelector$$anon$66 as $c_Lpresto_types$DirectiveSelector$$anon$66 };
$p = $c_Lpresto_types$DirectiveSelector$$anon$66.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveSelector$$anon$66;
/** @constructor */
function $h_Lpresto_types$DirectiveSelector$$anon$66() {
}
export { $h_Lpresto_types$DirectiveSelector$$anon$66 as $h_Lpresto_types$DirectiveSelector$$anon$66 };
$h_Lpresto_types$DirectiveSelector$$anon$66.prototype = $p;
$p.bn = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().ak(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bN = (function(text) {
  return ($m_Lpresto_types$DirectiveSelector$().a2O(text) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(text) : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "CSS Selector is not valid")));
});
$p.bJ = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$DirectiveSelector$$anon$66 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveSelector$$anon$66, "presto.types$DirectiveSelector$$anon$66", ({
  a03: 1,
  K: 1
}));
export { $d_Lpresto_types$DirectiveSelector$$anon$66 as $d_Lpresto_types$DirectiveSelector$$anon$66 };
//# sourceMappingURL=presto.types$-Directive-Selector$.js.map
